import { Injectable } from "@angular/core";
import { ApiService } from "../api/api.service";

import { environment } from "@env/environment";
import { Property } from "../../models/property/property.model";

@Injectable({
	providedIn: "root",
})
export class PropertiesService {
	constructor(private apiService: ApiService) {}

	fetchProperties(options?: any) {
		return this.apiService.get(`${environment.api_base_url}/properties`, options);
	}

	fetchPropertyList(options?: any) {
		return this.apiService.get(`${environment.api_base_url}/properties/list`, options);
	}

	fetchProperty(property_id: number, options?: any) {
		return this.apiService.get(`${environment.api_base_url}/properties/${property_id}`, options);
	}

	addProperties(property: Property | FormData, options?: any) {
		return this.apiService.post(`${environment.api_base_url}/properties`, property, options);
	}

	updateProperties(property_id: number, property: Property | FormData, options?: any) {
		return this.apiService.post(`${environment.api_base_url}/properties/${property_id}`, property, options);
	}

	deleteProperty(property_id: number, options?: any) {
		return this.apiService.delete(`${environment.api_base_url}/properties/${property_id}`, options);
	}
}
